// Environment configuration
const config = {
  development: {
    apiBaseUrl: 'http://localhost:5000/api',
    environment: 'development'
  },
  production: {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://reepo-backend.onrender.com/api',
    environment: 'production'
  }
}

// Get current environment
const env = import.meta.env.MODE || 'development'

// Export configuration for current environment
export default config[env] 